import { useEffect } from 'react';

export function ConfirmScript(props) {
  const { cost, appointmentId } = props;

  useEffect(() => {
    // GA4: fire pay_landing only after Square has confirmed payment and the
    // appointment record exists. This component only mounts on the confirm
    // step, so the event tracks true completed payments (not "Continue" clicks).
    if (typeof window.gtag === 'function' && appointmentId) {
      try {
        window.gtag('event', 'pay_landing', {
          currency: 'USD',
          value: Number(cost),
          transaction_id: appointmentId,
        });
      } catch (err) {
        console.error('GA4 pay_landing event failed:', err);
      }
    }
  }, [appointmentId]);
  return <></>;
}
